import { Keyword, List, Percentage, Position } from "@siteimprove/alfa-css";
import { Longhand } from "../longhand.js";
import { Resolver } from "../resolver.js";
const parse = List.parseCommaSeparated(Position.Component.parseVertical);
/**
 * @internal
 */
export const initialItem = Position.Side.of(Keyword.of("top"), Percentage.of(0));
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/background-position}
 * @internal
 */
export default Longhand.of(List.of([initialItem]), parse, (value, style) => value.map((positions) => positions.map(Position.Component.partiallyResolve(Resolver.length(style)))));
//# sourceMappingURL=background-position-y.js.map